import { authHeaders } from "./auth";
import { BACKEND_URL } from "./api";

// One key per user action, so a retried or replayed request is not counted twice
export function newIdempotencyKey() {
  if (window.crypto && typeof window.crypto.randomUUID === "function") {
    return window.crypto.randomUUID();
  }
  const bytes = new Uint8Array(16);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
}

// Download count the backend recorded for a /api/generate response (null if unavailable)
export function downloadCountFrom(response) {
  const value = response.headers.get("X-Download-Count");
  return value === null ? null : Number(value);
}

/**
 * Record a download of a form filled in the browser (forms 1, 3, 5, 28).
 * Counts and history are written by the backend only.
 * Returns the new download count, or null if the backend could not record it.
 */
export async function recordDownload(formName, creatorName, patentId, trackingNumber, applicantName) {
  const response = await fetch(`${BACKEND_URL}/api/downloads`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Idempotency-Key": newIdempotencyKey(),
      ...(await authHeaders()),
    },
    body: JSON.stringify({
      formName,
      creatorName: creatorName || "",
      patentId: patentId || "",
      trackingNumber: trackingNumber || "",
      applicantName: applicantName || "",
    }),
  });
  if (!response.ok) {
    throw new Error(`Could not record download (${response.status})`);
  }
  const data = await response.json();
  return data.count;
}
